namespace Areas.Finance.View {
    "use strict";

    var tabItems = Areas.createTabsWithSameAction("Finance", "View",
        ["Balances", "DailyGL", "MonthlyGL", "Funding", "IrsDeclarations", "Memos", "Research", "Reports"]);

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

}